import React from 'react'
import JobPostComponent from '../Components/JobPostComponent'
import RecruiterHeaderComponent from '../../Recruiter/Components/RecruiterHeaderComponent'

function CreateJobTemplatePage() {
  return (
    <div className="min-h-screen w-full bg-slate-950 py-10 px-4 sm:px-6 lg:px-8 selection:bg-cyan-500/30 selection:text-cyan-200">
        {/* <RecruiterHeaderComponent /> */}
        <div className="animate-fade-in">
          <JobPostComponent />
        </div>
    </div>
  )
}

export default CreateJobTemplatePage